import { ConcreteEncodable } from "./ConcreteEncodable";

import { ClientContactImplEncoder } from "../../encoder/ClientContactImplEncoder";

import * as CubiqTS from "../../index";
import { ClientContact } from "../ClientContact";

export class ClientContactImpl extends ConcreteEncodable implements ClientContact {
  public static enType: string = "com.bcdfx.model.ClientContactImpl";

  /*FID=1*/
  public id: CubiqTS.Long | null = null;
  /*FID=2*/
  public clientCd: string;
  /*FID=3*/
  public contactNameTxt: string;
  /*FID=4*/
  public deskTxt: string;
  /*FID=5*/
  public mobileTxt: string;
  /*FID=6*/
  public smsTxt: string;
  /*FID=7*/
  public emailTxt: string;
  /*FID=8*/
  public notifyEntry: CubiqTS.NotificationMethod;
  /*FID=9*/
  public notifyFill: CubiqTS.NotificationMethod;
  /*FID=10*/
  public notifyExpiry: CubiqTS.NotificationMethod;
  /*FID=11*/
  public isDefaultFg: boolean;
  /*FID=12*/
  public notifyModify: CubiqTS.NotificationMethod;
  /*FID=13*/
  public notifyCancel: CubiqTS.NotificationMethod;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ClientContactImplEncoder.Instance;
    this.setEncodableType(ClientContactImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ClientContactImpl[" +
      "id=" +
      this.id +
      "clientCd=" +
      this.clientCd +
      "contactNameTxt=" +
      this.contactNameTxt +
      "deskTxt=" +
      this.deskTxt +
      "mobileTxt=" +
      this.mobileTxt +
      "smsTxt=" +
      this.smsTxt +
      "emailTxt=" +
      this.emailTxt +
      "notifyEntry=" +
      this.notifyEntry +
      "notifyFill=" +
      this.notifyFill +
      "notifyExpiry=" +
      this.notifyExpiry +
      "isDefaultFg=" +
      this.isDefaultFg +
      "notifyModify=" +
      this.notifyModify +
      "notifyCancel=" +
      this.notifyCancel +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
